import { useCallback, useEffect, useState } from "react";

const useInView = (rootMargin = "200px 0px") => {
  const [node, setNode] = useState(null);
  const [inView, setInView] = useState(false);

  const ref = useCallback((el) => {
    setNode(el);
  }, []);

  useEffect(() => {
    if (!node || inView) return;

    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setInView(true);
      },
      { rootMargin },
    );

    obs.observe(node);
    return () => obs.disconnect();
  }, [node, inView, rootMargin]);

  return [ref, inView];
};

export default useInView;
